<div class="container-fluid octa-container-fluid">
    <div class="row">
        <div class="card octa-card">
            <div class="row octa-row">
                <div class="col-sm-6 hidden-mobile octa-hidden-mobile">
                </div>
                <div class="col-sm-6 octa-colsm-6">

                    <img src="../../../../../assets/Logo-new.svg" class="pt-3 oct-pt-3">
                    <h6>Login</h6>
                    <form name="form" class="p-2" (submit)="loginForm.form.valid && onSignIn(loginForm)"
                        #loginForm="ngForm" novalidate>
                        <div class="form-row">
                            <div class="form-group col">
                                <input type="text" class="form-control" name="email" [(ngModel)]="model.email"   maxlength="50" 
                                    placeholder="Email address" #email="ngModel" appDisableCopyPaste
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && email.invalid }" required email />
                                <div *ngIf="loginForm.submitted && email.invalid" class="invalid-feedback-text">
                                    <div *ngIf="email.errors.required">Email is required</div>
                                    <div *ngIf="email.errors.email">Please enter valid email</div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col mb-0">
                                <div class="input-group  ml-auto">
                                    <input [type]="fieldTextType ? 'text' : 'password'" name="password" maxlength="20" appDisableCopyPaste 
                                        placeholder="Password" class="form-control" [(ngModel)]="model.password"
                                        #password="ngModel" 
                                        [ngClass]="{ 'is-invalid-border': loginForm.submitted && password.invalid }"
                                        required>

                                    <span class="input-group-append" (click)="toggleFieldTextType()">
                                        <div class="input-group-text bg-transparent octa-bg-transparent"
                                            [ngClass]="{ 'is-invalid-border': loginForm.submitted && password.invalid }">
                                            <i class="fa" aria-hidden="true" [ngClass]="{
                                        'fa-eye-slash': !fieldTextType,
                                        'fa-eye': fieldTextType
                                      }"></i>
                                        </div>
                                    </span>
                                </div>
                                <div *ngIf="loginForm.submitted && password.invalid" class="invalid-feedback-text">
                                    <div *ngIf="password.errors.required">Password is required</div>
                                </div>
                            </div>

                        </div>
                        <div class="text-center mt-4 ">
                            <button class="  mr-1 mb-2 octa-mb-2" type="submit">Login</button>
                        </div>

                        <div class="text-center mt-2 forgot-password octa-forgot-password">
                            <a routerLink="/forgot-password">Forgot Password?</a>
                        </div>


                    </form>
                </div>
            </div>
        </div>
    </div>
</div>